import { render, staticRenderFns } from "./LeadDetails.vue?vue&type=template&id=14dec3c4&"
import script from "./LeadDetails.vue?vue&type=script&lang=ts&"
export * from "./LeadDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports